import site_logo from '../Assets/images/logo.png';
export const logo = site_logo;
export const title = 'Gs Infotech Web Solutions';
export const shortName = 'GS INFOTECH';
export const websiteURL = 'www.gsinfotechwebsolutions.com';

